import { CircularProgress } from '@mui/material'
import { GET_DASHBOARD_FOLLOWERS, getFollowers } from 'api'
import {
	BarElement,
	CategoryScale,
	Chart as ChartJS,
	Legend,
	LinearScale,
	Title,
	Tooltip
} from 'chart.js'
import { Box, GroupButton, TitleBox } from 'components'
import { BoxComponentProps, DataGraphicProps, Icons } from 'interfaces'
import React, { useEffect, useMemo, useState } from 'react'
import { Bar } from 'react-chartjs-2'
import { useQuery } from 'react-query'
import Cookies from 'universal-cookie'

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend)

export const Followers: React.FC<BoxComponentProps> = ({
	styles
}): JSX.Element => {
	const optionsToRender = useMemo(
		() => [
			{ name: '7 days', value: 'last_seven_days' },
			{ name: '6 months', value: 'six_months' },
			{ name: '12 months', value: 'twelve_months' }
		],
		[]
	)
	const graphOptions = useMemo(() => {
		return {
			maintainAspectRatio: false,
			responsive: true,
			plugins: {
				legend: {
					display: false
				}
			},
			scales: {
				x: {
					ticks: {
						color: '#000000',
						font: {
							family: 'Roboto Condensed'
						}
					}
				},
				y: {
					beginAtZero: true,
					ticks: {
						color: '#000000',
						font: {
							family: 'Roboto Condensed',
							size: 12
						}
					}
				}
			}
		}
	}, [])
	const [period, setPeriod] = useState(optionsToRender[0].value)
	const cookies = new Cookies()
	const userId = cookies.get('userId')
	const organizationId = cookies.get('organization_id')
	const { data, isLoading } = useQuery(
		[GET_DASHBOARD_FOLLOWERS, period, userId, organizationId],
		() => getFollowers(organizationId, period)
	)
	const [dataGraphic, setDataGraphic] = useState<DataGraphicProps>()

	// const { showToast } = useToast()
	// This should be refactor to a cron task
	// const downloadReportHandler = useCallback(async () => {
	// 	getDashboardReport().then(response => {
	// 		if (response) {
	// 			const lines = response.trim().split('\n')
	// 			const csvObj = lines.map(line => {
	// 				const [followersId, name, members, type] = line.split(',')
	// 				return {
	// 					'Follower ID': followersId,
	// 					Name: name,
	// 					Members: members,
	// 					Type: type
	// 				}
	// 			})
	// 			const csvData = Papa.unparse(csvObj)
	// 			const blob = new Blob([csvData], { type: 'text/csv;charset=utf-8' })
	// 			const link = document.createElement('a')
	// 			link.href = URL.createObjectURL(blob)
	// 			link.download = 'data.csv'
	// 			link.click()
	// 			showToast('Success', 'Data exported successfully', 'success')
	// 		}
	// 	})
	// }, [])

	useEffect(() => {
		if (data) {
			if (period === 'last_seven_days') {
				setDataGraphic({
					labels: data.map(item => item.name),
					datasets: [
						{
							label: optionsToRender[0].value,
							data: data.map(item => item.total),
							backgroundColor: '#17B3C5'
						}
					]
				})
			} else {
				setDataGraphic({
					labels: data.map(item => item.month_name),
					datasets: [
						{
							label: optionsToRender[0].value,
							data: data.map(item => item.total),
							backgroundColor: '#17B3C5'
						}
					]
				})
			}
		}
	}, [data])

	return (
		<div className={styles}>
			<TitleBox title="Followers" icon={Icons.personGeneric} className="mb-4" />
			<Box className="flex flex-col justify-between w-full h-[320px] p-[unset] px-[18px] py-2">
				<>
					<div className="flex justify-between">
						<GroupButton
							period={period}
							setPeriod={setPeriod}
							options={optionsToRender}
						/>
						{/* <Button
							label="Download List"
							iconLeft={Icons.download}
							color="Transparent"
							className="!min-w-[unset] !w-[168px] !h-8 !px-[unset] !py-[unset]"
							onClick={() => downloadReportHandler()}
						/> */}
					</div>
					<div className="w-full flex justify-center h-[250px]">
						{isLoading && (
							<div className="flex items-center justify-center w-full h-[200px] py-2 px-1 ">
								<CircularProgress disableShrink />
							</div>
						)}
						{dataGraphic && !isLoading && (
							<Bar
								data={dataGraphic}
								options={graphOptions}
								style={{ display: 'inline-block' }}
							/>
						)}
					</div>
				</>
			</Box>
		</div>
	)
}
